import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ShiftMultiSelectHelperService } from '../services/shift-multi-select-helper.service';

@Component({
  selector: 'wilson-message-with-undo-option',
  templateUrl: './message-with-undo-option.component.html',
  styleUrls: ['./message-with-undo-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, NzButtonModule],
})
export class MessageWithUndoOptionComponent {
  readonly shiftMultiSelectHelperService = inject(
    ShiftMultiSelectHelperService,
  );

  @Output() undo = new EventEmitter();

  async handleClick(): Promise<void> {
    this.undo.emit();
    // Wait for selection + group highlight restoration before closing the toast.
    await this.shiftMultiSelectHelperService.undoSelection();
  }
}
